import Vue from 'vue'
import Vuex from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import user from './modules/user'
import cart from './modules/cart'


Vue.use(Vuex)

export default new Vuex.Store({
  namespaced: true,
  state: {
    // 导航条, 布局风格, defalut(白色) / colorful(鲜艳)
    navbarLayoutType: 'colorful',
    // 侧边栏, 布局皮肤, default(白色) / dark(黑色)
    sidebarLayoutSkin: 'default',
    // 侧边栏, 折叠状态
    sidebarFold: false,
    // 侧边栏, 菜单
    sidebarMenuList: [],
    sidebarMenuActiveName: '',
    // 内容, 是否需要刷新
    contentIsNeedRefresh: false,
    // 内容, 标签页(默认添加首页)
    contentTabs: [
      {
        ...window.SITE_CONFIG['contentTabDefault'],
        name: 'home',
        title: 'home',
      },
    ],
    contentTabsActiveName: 'home',
    dictMap: [],
    campusList: [],
    _campus:{
      id:'',
      name:''
    },
    storeFormCart:{

    },
    waitPayList:[],
    sysType:'',
    pageTitleData:{}
  },
  modules: {
    cart, // 购物车 cart
    user,
  },
  getters: {
    currentCampus: (state, getters) => {
      let stored=localStorage.getItem('campus')
      if(stored){
        stored=JSON.parse(stored)
      }
      //先从vuex中获取
      if((!state._campus||!state._campus.id)&&stored){
        //内存中没有缓存中有
        state._campus=stored
      }
      return state._campus
    }
  },
  mutations: {
    changeCampus(state, val) {
      try {
        state._campus=val
        localStorage.setItem('campus',JSON.stringify(val))
      } catch (e) {
        console.log(e)
      }
    },
    // 重置vuex本地储存状态
    resetStore(state) {
      Object.keys(state).forEach((key) => {
        state[key] = cloneDeep(window.SITE_CONFIG['storeState'][key])
      })
    }
  },
})
